import type { HeroProps } from '@/components/imprint/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    ...sharedConfig['en-DE'].seo,
    title: 'Imprint | Lemonade',
    metaTitle: 'Imprint | Lemonade',
  },
  hero: {
    title: `A few things our lawyers thought you should know…\n(or, if you prefer, we’ve got a <a target="_blank" rel="noopener" href="/impressum.pdf" download>PDF version</a> as well)`,
  },
};
